import { Card, List, Spin } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

/* eslint-disable import/extensions */
import { MostActiveChannelsRpc } from "../../lib/discordTypes";
import { useEndTime, useStartTime } from "../DateContext/DateContext";
/* eslint-disable import/extensions */
import useMostActiveChannels from "./useMostActiveChannels";

/**
 * DiscordMostActiveMembersCard props
 * guildId: Discord guild id
 */
interface Props {
  guildId: string | null;
}

/**
 * A component that shows a list of the 10 most active Discord channels over a period of time
 *
 * @param props @see Props
 */
export default function DiscordMostActiveChannelsCard(props: Props) {
  const { guildId } = props;
  const { startTime, setStartTime } = useStartTime();
  const { endTime, setEndTime } = useEndTime();

  const { data: mostActiveChannels, isLoading: loading } =
    useMostActiveChannels(startTime, endTime, guildId);

    const navigate = useNavigate();

  return (
    <Card
      style={{ marginBottom: 40 }}
      title="Most active channels"
      bordered={false}
    >
      <Spin spinning={loading}>
        <List
          className="popular-channels"
          dataSource={mostActiveChannels || undefined}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={
                  <button
                    onClick={() =>
                      navigate(`/insights?channel=${item.channel_id}`)
                    }
                  >
                    #{item.channel_name}
                  </button>
                }
              />
              <div>
                {item.messages} {item.messages > 1 ? "messages" : "message"}
              </div>
            </List.Item>
          )}
        />
      </Spin>
    </Card>
  );
}
